// Created with: https://react-svgr.com/playground/?icon=true&ref=true&replaceAttrValues=%23fff%3DcurrentColor&svgoConfig=%7B%22plugins%22%3A%5B%7B%22name%22%3A%22preset-default%22%2C%22params%22%3A%7B%22overrides%22%3A%7B%22removeTitle%22%3Afalse%2C%22removeViewBox%22%3Afalse%7D%7D%7D%5D%7D&titleProp=true&typescript=true

import { SVGProps, Ref, forwardRef } from 'react'

interface SVGRProps {
  title?: string
  titleId?: string
}

const SvgComponent = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 25 25"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ?
      <title id={titleId}>{title}</title>
    : null}
    <circle
      cx={12.5}
      cy={12.5}
      r={11.5}
      stroke="currentColor"
      strokeWidth={2}
    />
    <path
      fill="currentColor"
      d="m17.062 8-6.083 6.082-4.02-4.02L5 12.02l4.02 4.021L10.98 18l1.958-1.959 6.083-6.082L17.06 8Z"
    />
  </svg>
)

const ForwardRef = forwardRef(SvgComponent)
export default ForwardRef
